import React from "react";
import BasicButton from "../theme/buttons/BasicButton";

export default class siteRouteCard extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderRouteSeats = () => {
    const routeSeats = this.props.data.routeseats.map((d, i) => {
      let crewcanvasser;
      this.props.crews.forEach((crew) => {
        if (crew.canvassers) {
          crewcanvasser = crew.canvassers.find(
            (cc) => cc.routeseat_id === d.routeseat_id
          );
        }
      });
      let canvasser =
        crewcanvasser &&
        this.props.canvassers.find((c) => c.id === crewcanvasser.canvasser_id);
      return (
        <div className="column column-20" key={d.routeseat_id}>
          <div className="routeseat-content-wrapper">
            <h5 className="primary-text">
              Seat {i + 1}
              <span
                onClick={() => this.props.handleRemoveSeat(d.routeseat_id)}
                className="remove-seat-icon far fa-times-circle"
              />
            </h5>
            <div style={{ marginBottom: "1em" }}>
              {canvasser && canvasser.firstname}{" "}
              {canvasser && canvasser.lastname}
            </div>
            <div className="">
              <button
                className="button button-outline"
                style={{ padding: "0 .3em", border: "none" }}
                onClick={() => this.props.handleAddSite(d)}
              >
                + Add Site
              </button>
            </div>
            {d.sites &&
              d.sites.map((s) => {
                return (
                  <div className="site-item">
                    <p className="card-line site-name">{s.site_name}</p>
                    <p className="card-line">
                      {s.addressline1}, {s.city}, {s.statecode}, {s.zip5}
                    </p>
                    <p
                      className="card-line primary-text"
                      onClick={() =>
                        this.props.handleRemoveSite({
                          routeseatsite_id: s.routeseatsite_id,
                          routeseat_id: d.routeseat_id,
                        })
                      }
                    >
                      <span className="remove-seat-icon far fa-times-circle" />
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });

    routeSeats.push(
      <div className="column column-25">
        <BasicButton
          // title='Add a seat'
          label="Add A Seat"
          style={{ margin: "2px" }}
          on_click={(val) => {
            this.props.handleAddSeat();
          }}
        />
      </div>
    );

    return routeSeats;
  };

  render() {
    let data = this.props.data;
    return (
      <div className="card wox-card simple-route-card">
        <h3 className="primary-text">{data.siteroute_name}</h3>
        <div className="row" style={{ maxWidth: "100%", overflow: "scroll" }}>
          {this.renderRouteSeats()}
        </div>
      </div>
    );
  }
}

const styles = {
  siteName: {
    fontWeight: "bold",
  },
  cardLine: {
    display: "block",
    marginBottom: "8px",
    fontSize: "13px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  siteItem: {
    marginBottom: "1em",
    marginTop: "1em",
    paddingLeft: ".75em",
    borderLeft: "2px solid #9b4dca",
    height: "5em",
    overflow: "hidden",
  },
};

//not used. left here only for reference
const sampledata = {
  siteroute_id: 1569,
  siteroute_name: "04 - CCC",
  hex_color: "#9C27B0",
  created_at: "2020-01-13T23:49:30.289622",
  sitecanvass_id: 80,
  routeseats: [
    {
      routeseat_id: 10039,
      canvasser_type_id: 1,
      type_name: "Driver",
      sites: [
        {
          routeseatsite_id: 80557,
          site_order_position: 1,
          site_id: 20570,
          site_name:
            "Flagstaff.Coconino Community College. 2800 S Lone Tree Rd, Flagstaff, AZ 86005",
          description: "",
          addressline1: "2800 S Lone Tree Rd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86005",
          lat: "35.1711439",
          lon: "-111.6454846",
        },
        {
          routeseatsite_id: 80559,
          site_order_position: 2,
          site_id: 20571,
          site_name:
            "Flagstaff.Walmart.2750 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2750 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1764629",
          lon: "-111.6647683",
        },
      ],
    },
    {
      routeseat_id: 10040,
      canvasser_type_id: 2,
      type_name: "Team Leader",
      sites: [
        {
          routeseatsite_id: 80558,
          site_order_position: 1,
          site_id: 20570,
          site_name:
            "Flagstaff.Coconino Community College. 2800 S Lone Tree Rd, Flagstaff, AZ 86005",
          description: "",
          addressline1: "2800 S Lone Tree Rd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86005",
          lat: "35.1711439",
          lon: "-111.6454846",
        },
        {
          routeseatsite_id: 80560,
          site_order_position: 2,
          site_id: 20571,
          site_name:
            "Flagstaff.Walmart.2750 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2750 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1764629",
          lon: "-111.6647683",
        },
      ],
    },
    {
      routeseat_id: 10041,
      canvasser_type_id: 3,
      type_name: "Canvasser",
      sites: [
        {
          routeseatsite_id: 80562,
          site_order_position: 1,
          site_id: 20571,
          site_name:
            "Flagstaff.Walmart.2750 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2750 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1764629",
          lon: "-111.6647683",
        },
        {
          routeseatsite_id: 88403,
          site_order_position: 2,
          site_id: 20593,
          site_name:
            "Flagstaff.Bashas'.2700 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2700 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1766556",
          lon: "-111.6674941",
        },
      ],
    },
    {
      routeseat_id: 12511,
      canvasser_type_id: 3,
      type_name: "Canvasser",
      sites: [
        {
          routeseatsite_id: 88397,
          site_order_position: 1,
          site_id: 20575,
          site_name:
            "Flagstaff.U.S. Social Security Administration.2715 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2715 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1756517",
          lon: "-111.668448",
        },
        {
          routeseatsite_id: 88398,
          site_order_position: 2,
          site_id: 20593,
          site_name:
            "Flagstaff.Bashas'.2700 S Woodlands Village Blvd, Flagstaff, AZ 86001",
          description: "",
          addressline1: "2700 S Woodlands Village Blvd",
          city: "Flagstaff",
          statecode: "AZ",
          zip5: "86001",
          lat: "35.1766556",
          lon: "-111.6674941",
        },
      ],
    },
  ],
};
